module.exports = __webpack_public_path__ + "static/media/gallery-5.cb1568cf.jpeg";